import React from "react";
import { Marker } from "@react-google-maps/api";

const MapMarker = ({
  latitude,
  longitude,
  post,
  setSelected,
  setShowMenu,
  setShowSearch,
}) => (
  <Marker
    position={{
      lat: parseFloat(latitude),
      lng: parseFloat(longitude),
    }}
    icon={{
      anchor: new window.google.maps.Point(15, 15),
      origin: new window.google.maps.Point(0, 0),
      scaledSize: new window.google.maps.Size(30, 30),
      url: `/cat.svg`,
    }}
    onClick={() => {
      setSelected(null);
      setSelected(post);
      setShowSearch(false);
      setShowMenu(false);
    }}
  />
);

export default MapMarker;
